module.exports = __webpack_public_path__ + "img/챔피언.a32dba43.png";